module.exports = __webpack_public_path__ + "static/media/spaceAdventure.11e57728.gif";